export default "__VITE_ASSET__CqdC7$cP__"